import { css } from 'styled-components';
import { mediaQuery } from 'src/app/styles/helper';

export type BreakpointType = 'sm' | 'md' | 'lg' | 'xl' | '2xl';

export interface VisibilityProps {
  hideOn?: BreakpointType;
  showOn?: BreakpointType;
  overflow?: 'visible' | 'hidden' | 'scroll' | 'auto';
}

export type StyledVisibilityProps = {
  [K in keyof VisibilityProps as `$${K}`]: VisibilityProps[K];
};

export const visibilityStyles = css<StyledVisibilityProps>`
  ${({ $showOn }) =>
    $showOn &&
    css`
      display: none;

      ${mediaQuery(
        $showOn,
        css`
          display: var(--layout-display-property);
        `
      )}
    `}

  ${({ $hideOn }) =>
    $hideOn &&
    mediaQuery(
      $hideOn,
      css`
        display: none;
      `
    )}

  ${({ $overflow }) =>
    $overflow &&
    css`
      overflow: ${$overflow};
    `}
`;
